import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import { Localization } from 'connex-cds';

export const RowActionsMenu = ({ assignment, onView, onActivate, onDeactivate, onCreateTicket }) => {
  const translateMessage = Localization.useTranslateMessage();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = event => {
    event?.stopPropagation?.();
    setAnchorEl(event?.currentTarget);
  };

  const handleClose = event => {
    event?.stopPropagation?.();
    setAnchorEl(null);
  };

  const handleView = event => {
    event?.stopPropagation?.();
    setAnchorEl(null);
    onView?.(assignment);
  };

  const handleActivate = event => {
    event?.stopPropagation?.();
    setAnchorEl(null);
    onActivate?.(assignment);
  };

  const handleDeactivate = event => {
    event?.stopPropagation?.();
    setAnchorEl(null);
    onDeactivate?.(assignment?.scheduledLoadRef);
  };

  const handleCreateTicket = event => {
    event?.stopPropagation?.();
    setAnchorEl(null);
    onCreateTicket?.(assignment);
  };

  return (
    <>
      <IconButton
        size="small"
        aria-label={translateMessage('loadAssignment_actions')}
        data-testid="load-assignment-row-actions"
        onClick={handleOpen}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} onClick={event => event?.stopPropagation?.()}>
        <MenuItem onClick={handleView} data-testid="load-assignment-action-view">
          <ListItemIcon>
            <VisibilityOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{translateMessage('loadAssignment_view')}</ListItemText>
        </MenuItem>
        <MenuItem
          disabled={!assignment?.canActivate}
          onClick={handleActivate}
          data-testid="load-assignment-action-activate"
        >
          <ListItemIcon>
            <PlayArrowOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{translateMessage('loadAssignment_activate')}</ListItemText>
        </MenuItem>
        <MenuItem
          disabled={!assignment?.isActive}
          onClick={handleDeactivate}
          data-testid="load-assignment-action-deactivate"
        >
          <ListItemIcon>
            <CloseOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{translateMessage('loadAssignment_deactivate')}</ListItemText>
        </MenuItem>
        <MenuItem
          disabled={!assignment?.isActive}
          onClick={handleCreateTicket}
          data-testid="load-assignment-action-create-ticket"
        >
          <ListItemIcon>
            <ConfirmationNumberOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{translateMessage('loadAssignment_createTicket')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
